/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentRule } from './AssignmentRule';
import {
    AssignmentRuleFromJSON,
    AssignmentRuleFromJSONTyped,
    AssignmentRuleToJSON,
    AssignmentRuleToJSONTyped,
} from './AssignmentRule';

/**
 * 
 * @export
 * @interface CreateAssignmentRule201Response
 */
export interface CreateAssignmentRule201Response {
    /**
     * 
     */
    data: AssignmentRule;
}

/**
 * Check if a given object implements the CreateAssignmentRule201Response interface.
 */
export function instanceOfCreateAssignmentRule201Response(value: object): value is CreateAssignmentRule201Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateAssignmentRule201ResponseFromJSON(json: any): CreateAssignmentRule201Response {
    return CreateAssignmentRule201ResponseFromJSONTyped(json, false);
}

export function CreateAssignmentRule201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssignmentRule201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AssignmentRuleFromJSON(json['data']),
    };
}

export function CreateAssignmentRule201ResponseToJSON(json: any): CreateAssignmentRule201Response {
    return CreateAssignmentRule201ResponseToJSONTyped(json, false);
}

export function CreateAssignmentRule201ResponseToJSONTyped(value?: CreateAssignmentRule201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AssignmentRuleToJSON(value['data']),
    };
}

